
const AlertPanelComponent = {
    template: require("./alerts-panel.html"),
    restrict: 'E',
    controllerAs: 'vm',
    controller: AlertPanelController,
    bindings: {
        series: '<'
    }
};

function AlertPanelController() {

    var vm = this;
    vm.erroringSeries = [];

    vm.$onChanges = function (changes) {
        if (changes.series && changes.series.currentValue) {
            vm.erroringSeries = _.filter(vm.series, function (series) {
                return series.gauge && (series.gauge.state.status === 'error' || series.gauge.state.status === 'warning');
            });
        }
    };
}

export default AlertPanelComponent;
